<router-outlet></router-outlet>
<ng-template #updateNotificatiion let-notification>
  <div class="ant-notification-notice-content">
    <div>
      <div class="ant-notification-notice-message t-medium" i18n>
        Update available
      </div>
      <div class="ant-notification-notice-description" i18n>
        A new version is available. Reload the app to get the latest update.
      </div>
      <span class="ant-notification-notice-btn">
        <un-button type="primary" (btnClick)="reload(notification)" i18n>
          Reload App
        </un-button>
      </span>
    </div>
  </div>
</ng-template>
